import { c as _c } from "react-compiler-runtime";
import { useCompilerRenderMetricsWithReasonTracking } from 'react-performance-metrics-lib/hooks/use-render-metrics';
import { Metrics } from '../Metrics';
const EMPTY_OBJECT = {};
export function useMessageHistoryPerformanceMeasurement(t0) {
  const $ = _c(3);
  const {
    componentName,
    compilerOptimized: t1,
    propsToTrack: t2,
    routeName,
    stateToTrack
  } = t0;
  const compilerOptimized = t1 === undefined ? true : t1;
  const propsToTrack = t2 === undefined ? EMPTY_OBJECT : t2;
  let t3;
  if ($[0] !== compilerOptimized || $[1] !== routeName) {
    t3 = {
      compilerOptimized,
      routeName
    };
    $[0] = compilerOptimized;
    $[1] = routeName;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useCompilerRenderMetricsWithReasonTracking(componentName, propsToTrack, Metrics, stateToTrack, t3);
}